import styled from '@emotion/styled'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { object, func } from 'prop-types'
import { casingTypes, spacingTypes } from '@global/constants'
import { CvsAutoComplete } from '../components'
import { isSplitGovernanceTypeForDestination, belongsToPattern } from './split-actions'
import { SplitText } from './split-text'
import { t } from '@lingui/core/macro'

const transformation = {
  UPPERCASE: { uppercase: true, lowercase: false },
  LOWERCASE: { uppercase: false, lowercase: true },
  REMOVE: { remove_spaces: true, replace_spaces_with: null },
  REPLACE: { remove_spaces: true, replace_spaces_with: '' },
}

const caseNone = {
  uppercase: false,
  lowercase: false,
}

const spaceNone = {
  remove_spaces: false,
  replace_spaces_with: null,
}

const FillAutocomplete = styled(CvsAutoComplete)`
  width: 100%;
`

const FillAutocompleteMarginLeft = styled(CvsAutoComplete)`
  margin-left: 8px;
`

const MarginTopTypography = styled(Typography)`
  margin-top: 12px;
`

export const Transform = ({ form, setForm, disabled }) => {
  return (
    <>
      <MarginTopTypography variant="subtitle1">{t`Transform`}</MarginTopTypography>
      <Box display="inline-flex" justify-content="space-between">
        <FillAutocomplete
          name="transform-case"
          margin="dense"
          disabled={disabled}
          label={t`Convert case`}
          options={Object.keys(casingTypes).map(key => ({ label: casingTypes[key], value: key }))}
          onSelected={value => {
            const spreadableValue = value === 'NONE' ? caseNone : transformation[value]
            setForm(prev => ({
              ...prev,
              transformation: { ...prev.transformation, ...spreadableValue },
            }))
          }}
          selected={
            form.transformation.uppercase
              ? 'UPPERCASE'
              : form.transformation.lowercase
                ? 'LOWERCASE'
                : 'NONE'
          }
        />
        <FillAutocompleteMarginLeft
          name="transform-spaces"
          margin="dense"
          label={t`Spaces`}
          disabled={disabled}
          options={Object.keys(spacingTypes).map(key => ({ label: spacingTypes[key], value: key }))}
          onSelected={value => {
            const spreadableValue = value === 'NONE' ? spaceNone : transformation[value]
            setForm(prev => ({
              ...prev,
              transformation: { ...prev.transformation, ...spreadableValue },
            }))
          }}
          selected={
            typeof form.transformation.replace_spaces_with === 'string'
              ? 'REPLACE'
              : form.transformation.remove_spaces
                ? 'REMOVE'
                : 'NONE'
          }
        />
      </Box>
      {typeof form.transformation.replace_spaces_with === 'string' && (
        <TextField
          name="replace-spaces-with"
          margin="dense"
          disabled={disabled}
          variant="outlined"
          label={t`Replace spaces`}
          placeholder='example: "-"'
          value={form.transformation.replace_spaces_with}
          onChange={({ target: { value } }) =>
            setForm(prev => ({
              ...prev,
              transformation: { ...prev.transformation, replace_spaces_with: value },
            }))
          }
        />
      )}
      {isSplitGovernanceTypeForDestination(form.governance_type) && !belongsToPattern(form) ? (
        <SplitText form={form} setForm={setForm} disabled={disabled} />
      ) : null}
    </>
  )
}

Transform.propTypes = {
  form: object.isRequired,
  setForm: func.isRequired,
}
